<template>
  <section class="section-graphs">
    <div v-show="campaignsGraphActive === 0" class="graph graph-pie">
      <div class="chart-list">

        <div class="chart-item" ref="impressionsContainer">
          <div class="chart-titles">
            <div class="chart-title">
              <span class="chart-title-t">
                <span>{{ $t("Campaigns.Charts.Impressions.Title") }}</span>
              </span>
              <span class="chart-title-b text-grey">{{stats ? stats.ImpressionCount : ""}}</span>
              <span class="chart-title-b-m">{{stats ? stats.ImpressionCount : ""}}</span>
            </div>
            <div class="chart-title chart-title-second">
              <span class="chart-title-t">{{ $t("Campaigns.Charts.Impressions.Price1k") }}</span>
              <span class="chart-title-b text-grey">₪{{stats && stats.Impressions1kPrice ? parseFloat(stats.Impressions1kPrice.toFixed(2)) : 0}}</span>
            </div>
          </div>
          <div class="chart-container">
            <CampaignsGraphPie :width="164" :height="164" :chart-data="impressionsChartData" :options="generatePieChartOptions($refs.impressionsChart, ChartType.CampaignsImpressions)"
                ref="impressionsChart" />
          </div>
        </div>

        <div class="chart-item" ref="clicksContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t("Campaigns.Charts.Clicks.Title") }}</span>
            <span class="chart-title-b text-grey">{{stats ? stats.ClickCount : ""}}</span>
          </div>
          <div class="chart-container">
            <CampaignsGraphPie :width="164" :height="164" :chart-data="clicksChartData" :options="generatePieChartOptions($refs.clicksChart, ChartType.CampaignsClicks)"
                ref="clicksChart" />
          </div>
        </div>
        <div class="chart-item" ref="budgetContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t("Campaigns.Charts.Budget.Title") }}</span>
            <span class="chart-title-b text-grey">₪{{stats && stats.Budget ? parseFloat(stats.Budget.toFixed(2)) : 0}}</span>
          </div>
          <div class="chart-container">
            <CampaignsGraphPie :width="164" :height="164" :chart-data="budgetChartData" :options="generatePieChartOptions($refs.budgetChart, ChartType.CampaignsBudget)"
                ref="budgetChart" />
          </div>
        </div>
        <div class="chart-item" ref="leadsContainer">
          <div class="chart-titles">
            <div class="chart-title">
              <span class="chart-title-t">{{ $t("Campaigns.Charts.Leads.Title") }}</span>
              <span class="chart-title-b text-grey">{{stats ? stats.LeadCount : 0}}</span>
            </div>
            <div class="chart-title chart-title-second">
              <span class="chart-title-t">
                <span>{{ $t("Campaigns.Charts.Leads.AvgPrice") }}</span>
              </span>
              <span class="chart-title-b text-grey">₪{{stats && stats.AverageLeadCost ? parseFloat(stats.AverageLeadCost.toFixed(2)) : 0}}</span>
            </div>
          </div>
          <div class="chart-container">
            <CampaignsGraphPie :width="164" :height="164" :chart-data="leadsChartData" :options="generatePieChartOptions($refs.leadsChart, ChartType.CampaignsLeads)"
                ref="leadsChart" />
          </div>
        </div>
        <div class="chart-item" ref="meetingsContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t("Campaigns.Charts.Meetings.Title") }}</span>
            <span class="chart-title-b text-grey">{{stats ? stats.MeetingCount : 0}}</span>
          </div>
          <div class="chart-container">
            <CampaignsGraphPie :width="164" :height="164" :chart-data="meetingsChartData" :options="generatePieChartOptions($refs.meetingsChart, ChartType.CampaignsMeetings)"
                ref="meetingsChart" />
          </div>
        </div>
        <div class="chart-item" ref="dealsContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t("Campaigns.Charts.Deals.Title") }}</span>
            <span class="chart-title-b text-grey">{{stats ? stats.DealCount : 0}}</span>
          </div>
          <div class="chart-container">
            <CampaignsGraphPie :width="164" :height="164" :chart-data="dealsChartData" :options="generatePieChartOptions($refs.dealsChart, ChartType.CampaignsDeals)"
                ref="dealsChart" />
          </div>
        </div>
      </div>
    </div>
    <mq-layout v-show="campaignsGraphActive === 1" class="graph graph-line" mq="lg">
      <div class="chart-item" ref="lineChartDataContainer">
        <div class="chart-labels" ref="lineChartLabels">
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsLeads)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsLeads, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-primary"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsLeads), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsLeads)">
              {{ $t("Campaigns.Charts.DayByDay.Leads") }}: {{ stats.LeadCount }}
            </div>
          </div>
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsMeetings)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsMeetings, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-warning"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsMeetings), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsMeetings)">
              {{ $t("Campaigns.Charts.DayByDay.Meetings") }}: {{ stats.MeetingCount }}
            </div>
          </div>
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsDeals)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsDeals, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-success"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsDeals), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsDeals)">
              {{ $t("Campaigns.Charts.DayByDay.Deals") }}: {{ stats.DealCount }}
            </div>
          </div>
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsDealsAmount)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsDealsAmount, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-success-dark"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsDealsAmount), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsDealsAmount)">
              {{ $t("Campaigns.Charts.DayByDay.DealsAmount") }}: ₪{{stats && stats.DealAmount ? parseFloat(stats.DealAmount.toFixed(2)) : 0}}
            </div>
          </div>
          <hr />
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsImpressions)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsImpressions, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-dark"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsImpressions), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsImpressions)">
              {{ $t("Campaigns.Charts.DayByDay.Impressions") }}: {{ stats.ImpressionCount }}
            </div>
          </div>
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsClicks)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsClicks, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-lgrey"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsClicks), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsClicks)">
              {{ $t("Campaigns.Charts.DayByDay.Clicks") }}: {{ stats.ClickCount }}
            </div>
          </div>
          <div class="chart-label">
            <b-field>
              <b-checkbox :value="showInByDateChart.includes(ChartType.CampaignsBudget)" size="is-small"
                    @input="onShowByDateChartChange(ChartType.CampaignsBudget, $event)"></b-checkbox>
            </b-field>
            <div class="color has-background-danger"></div>
            <div :class="{ disabled: !showInByDateChart.includes(ChartType.CampaignsBudget), txt: true}"
                  @click="onShowByDateChartChange(ChartType.CampaignsBudget)">
              {{ $t("Campaigns.Charts.DayByDay.Budget") }}: ₪{{stats && stats.Budget ? parseFloat(stats.Budget.toFixed(2)) : 0}}
            </div>
          </div>
        </div>
        <div class="chart-container">
          <CampaignsGraphLine :height="250" :chart-data="lineChartData.chartData" :options="lineChartOptions" ref="byDateChart" />
        </div>
      </div>
    </mq-layout>

    <div class="graphs-bottom-panel">
      <div class="graphs-roi">
        <span class="roi-label">{{ $t("Campaigns.Charts.ROI") }}</span>
        <span class="roi-val">{{ ROI }}</span>
        <b-tooltip position="is-top" multilined type="is-dark" ref="roiTooltip">
          <span class="roi-help" @mouseover="handleRoiTooltipPosition">
            <icon-base width="17" height="17" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
          </span>
          <template #content>
            <div v-html="$t('Campaigns.Charts.ROITooltip')"></div>
          </template>
        </b-tooltip>
      </div>
      <mq-layout class="graphs-view-tabs" mq="lg">
        <div class="tab" :class="campaignsGraphActive == 0 ? 'is-active' : ''" @click="setGraphActive(0, ChartType.CampaignsBudget)">
          <icon-base width="20" height="20" view-box="0 0 20 20" icon-name="chart-pie"><icon-chart-pie /></icon-base>
          <span>{{ $t("LeadsGraphs.PiePanel") }}</span>
        </div>
        <div class="tab" :class="campaignsGraphActive == 1 ? 'is-active' : ''" @click="setGraphActive(1, ChartType.CampaignsByDate)">
          <icon-base width="22" height="12" view-box="0 0 22 12" icon-name="chart-line"><icon-chart-line /></icon-base>
          <span>{{ $t("LeadsGraphs.LinePanel") }}</span>
        </div>
      </mq-layout>
      <div class="graphs-date-comparison">
        <b-button tag="a" href="#" class="is-icon">
          <icon-base width="23" height="21" view-box="0 0 23 21" icon-name="calendar-time"><icon-calendar-time /></icon-base>
          <span>השוואת תאריכים </span>
        </b-button>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ChartData, ChartDataSets, ChartOptions, ChartPoint } from "chart.js";
import moment from "moment";
import { LoaderComponent } from "vue-loading-overlay";
import VueMq from "vue-mq";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import { ChartType } from "@/models/ChartType";
import { CampaignGridView } from "@/models/campaigns/CampaignGridView";
import { CampaignsStatisticsByDate } from "@/models/campaigns/CampaignsStatisticsByDate";
import { CampaignsStats } from "@/models/campaigns/CampaignsStats";
import { ChannelType } from "@/models/campaigns/ChannelType";
import ChartService from "@/services/ChartService";
import HelperService from "@/services/HelperService";
import CampaignsGraphLine from "./CampaignsGraphLine.vue";
import CampaignsGraphPie from "./CampaignsGraphPie.vue";
import IconBase from "../IconBase.vue";
import IconCalendarTime from "../icons/IconCalendarTime.vue";
import IconChartLine from "../icons/IconChartLine.vue";
import IconChartPie from "../icons/IconChartPie.vue";
import IconQuestionCircle from "../icons/IconQuestionCircle.vue";

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});

const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconChartPie,
    IconChartLine,
    IconCalendarTime,
    IconQuestionCircle,
    CampaignsGraphLine,
    CampaignsGraphPie,
  },
})
export default class CampaignsGraphs extends Vue {

  //#region Vuex getters and actions
  
  @Getter("campaignsStatsByDate", { namespace }) campaignsStatsByDate!: CampaignsStatisticsByDate[] | null;
  @Getter("campaignsWithStats", { namespace }) campaignsWithStats!: CampaignGridView[] | null;
  @Action("setSelectedCampaignsIds", { namespace }) setSelectedCampaignsIds!: (selectedCampaignsIds: number[]) => void;
  
  //#endregion Vuex getters and actions


  //#region Properties

  campaignsGraphActive = 0;

  stats: CampaignsStats = {};
  budgetChartData: ChartData = {};
  clicksChartData: ChartData = {};
  dealsChartData: ChartData = {};
  impressionsChartData: ChartData = {};
  leadsChartData: ChartData = {};
  meetingsChartData: ChartData = {};
  lineChartData: LineChartData = {};

  budgetLoader?: LoaderComponent = undefined;
  campaignsStatsByDateLoader?: LoaderComponent = undefined;
  clicksLoader?: LoaderComponent = undefined;
  dealsLoader?: LoaderComponent = undefined;
  impressionsLoader?: LoaderComponent = undefined;
  leadsLoader?: LoaderComponent = undefined;
  lineChartLabelsLoader?: LoaderComponent = undefined;
  meetingsLoader?: LoaderComponent = undefined;

  statsCache: CampaignsStatisticsByDate[] = [];

  ChartType = ChartType;

  lineChartOptions: ChartOptions = {
    legend: {
      display: false,
    },
    layout: {
      padding: 0,
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            display: true,
          },
          ticks: {
            stepSize: 10,
            suggestedMin: 0,
            suggestedMax: 10,
          },
        },
      ],
      xAxes: [
        {
          type: "time",
          ticks: {
            autoSkip: true,
            maxRotation: 0,
            maxTicksLimit: 14,
          },
          time: {
            unit: "day",
            displayFormats: {
              day: "DD/MM/YYYY",
            },
            tooltipFormat: "DD/MM/YYYY",
          }
        },
      ],
    },
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: 2,
      },
    },
    animation: {
      duration: 0,
    },
    hover: {
      animationDuration: 200,
    },
    responsiveAnimationDuration: 0,
    plugins: {
      datalabels: {
        display: false,
      },
    },
    tooltips: {
      mode: "index"
    }
  };

  showInByDateChart: ChartType[] = [
    ChartType.CampaignsLeads,
    ChartType.CampaignsMeetings,
    ChartType.CampaignsDeals,
    // ChartType.CampaignsDealsAmount,
    ChartType.CampaignsImpressions,
    ChartType.CampaignsClicks,
    // ChartType.CampaignsBudget,
  ];

  //#endregion Properties


  //#region Watches

  @Watch("campaignsStatsByDate", { immediate: true })
  onCampaignsStatsByDateChange(newStats: CampaignsStatisticsByDate[] | null, oldStats: CampaignsStatisticsByDate[] | null): void {
    this.campaignsStatsByDateLoader =
        this.toggleGraphLoader(newStats === null, this.campaignsStatsByDateLoader, this.$refs.lineChartDataContainer as Element);
    this.lineChartData = this.getLineChartData(newStats);
    this.statsCache = newStats ?? [];
  }

  @Watch("campaignsWithStats", { immediate: true })
  onCampaignsWithStatsChange(newCampaignsWithStats: CampaignGridView[] | null, oldCampaignsWithStats: CampaignGridView[] | null): void {
    this.budgetLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.budgetLoader, this.$refs.budgetContainer as Element);
    this.clicksLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.clicksLoader, this.$refs.clicksContainer as Element);
    this.dealsLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.dealsLoader, this.$refs.dealsContainer as Element);
    this.impressionsLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.impressionsLoader, this.$refs.impressionsContainer as Element);
    this.leadsLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.leadsLoader, this.$refs.leadsContainer as Element);
    this.meetingsLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.meetingsLoader, this.$refs.meetingsContainer as Element);
    this.lineChartLabelsLoader = this.toggleGraphLoader(newCampaignsWithStats === null, this.lineChartLabelsLoader, this.$refs.lineChartLabels as Element);
    this.stats = {};
    if (newCampaignsWithStats !== null) {
      this.budgetChartData = this.getChartData(newCampaignsWithStats, ChartType.CampaignsBudget);
      if (this.$refs.budgetChart) {
        (this.$refs.budgetChart as any).refreshChart();
      }
      this.clicksChartData = this.getChartData(newCampaignsWithStats, ChartType.CampaignsClicks);
      if (this.$refs.clicksChart) {
        (this.$refs.clicksChart as any).refreshChart();
      }
      this.dealsChartData = this.getChartData(newCampaignsWithStats, ChartType.CampaignsDeals);
      if (this.$refs.dealsChart) {
        (this.$refs.dealsChart as any).refreshChart();
      }
      this.impressionsChartData = this.getChartData(newCampaignsWithStats, ChartType.CampaignsImpressions);
      if (this.$refs.impressionsChart) {
        (this.$refs.impressionsChart as any).refreshChart();
      }
      this.leadsChartData = this.getChartData(newCampaignsWithStats, ChartType.CampaignsLeads);
      if (this.$refs.leadsChart) {
        (this.$refs.leadsChart as any).refreshChart();
      }
      this.meetingsChartData = this.getChartData(newCampaignsWithStats, ChartType.CampaignsMeetings);
      if (this.$refs.meetingsChart) {
        (this.$refs.meetingsChart as any).refreshChart();
      }
      this.getChartData(newCampaignsWithStats, ChartType.CampaignsDealsAmount); // chart for deal amount not exists, just fill stats
    }
  }

  //#endregion Watches


  //#region Getters

  get ROI(): string {
    let roiValue = 0;
    if (this.stats.Budget) {
      roiValue = ((this.stats.DealAmount || 0) - this.stats.Budget) / this.stats.Budget;
    }
    roiValue = parseFloat(roiValue.toFixed(2));
    const roiValue100 = parseFloat((roiValue * 100).toFixed(2));
    return `${roiValue} (${roiValue100}%)`;
  }

  //#endregion Getters


  //#region Handlers

  onShowByDateChartChange(type: ChartType, show?: boolean) {
    if (show === undefined) {
      show = !this.showInByDateChart.includes(type);
    }
    if (show) {
      this.showInByDateChart.push(type);
    } else {
      this.showInByDateChart.splice(this.showInByDateChart.indexOf(type), 1);
    }
    this.lineChartData = this.getLineChartData(this.statsCache);
  }

  //#endregion Handlers


  //#region Private methods

  applyGraphClickFilters(chartType: ChartType, label: string) {
    let channelTitle = this.getChannelTitleFromChartLabel(label);
    if (!channelTitle) {
      return;
    }
    const channel: CampaignGridView | undefined = this.campaignsWithStats?.find(i => i.ChannelTitle === channelTitle);
    if (channel) {
      this.setSelectedCampaignsIds([channel.ChannelId]);
    } else {
      HelperService.showMessage("", i18n.t("Leads.Graphs.ChannelNotActive").toString());
    }
  }

  // Check if mouse pointer will look as hand when hover over chart. This method linked to method "applyGraphClickFilters"
  applyGraphClickFiltersCheckCanHover(chartType: ChartType, label: string): boolean {
    let channelTitle = this.getChannelTitleFromChartLabel(label);
    if (!channelTitle) {
      return false;
    }
    const channel: CampaignGridView | undefined = this.campaignsWithStats?.find(i => i.ChannelTitle === channelTitle);
    return !!channel;
  }

  generatePieChartOptions(chartEl: Vue, chartType: ChartType): ChartOptions | undefined {
    return ChartService.generatePieChartOptions(chartEl, chartType, this.applyGraphClickFilters, this.applyGraphClickFiltersCheckCanHover);
  }

  getChannelTitleFromChartLabel(label: string): string | undefined {
    const labelParts: string[] = label.split('<br />');
    return labelParts.length > 0 ? labelParts[1] : undefined;
  }

  getChartData(campaignsWithStats: CampaignGridView[] | null, chartType: ChartType): ChartData {
    let newCampaignsWithStats: CampaignGridView[];
    let colors: string[] = [];
    let data: number[] = [];
    let labels: string[] = [];
    if (campaignsWithStats) {
      newCampaignsWithStats = [...campaignsWithStats].filter((i: CampaignGridView) => {
        switch (chartType) {
          case ChartType.CampaignsBudget:
            return i.Cost && i.Cost > 0;
          case ChartType.CampaignsClicks:
            return i.ClickCount && i.ClickCount > 0;
          case ChartType.CampaignsDeals:
            return i.DealCount && i.DealCount > 0;
          case ChartType.CampaignsDealsAmount:
            return i.DealAmount && i.DealAmount > 0;
          case ChartType.CampaignsImpressions:
            return i.ImpressionCount && i.ImpressionCount > 0;
          case ChartType.CampaignsLeads:
            return i.LeadCount && i.LeadCount > 0;
          case ChartType.CampaignsMeetings:
            return i.MeetingCount && i.MeetingCount > 0;
          default:
            return false;
        }
      }).sort((a: CampaignGridView, b: CampaignGridView) => {
        switch (chartType) {
          case ChartType.CampaignsBudget:
            if (!a.Cost || !b.Cost) {
              return 0;
            }
            return b.Cost - a.Cost;
          case ChartType.CampaignsClicks:
            if (!a.ClickCount || !b.ClickCount) {
              return 0;
            }
            return b.ClickCount - a.ClickCount;
          case ChartType.CampaignsDeals:
            if (!a.DealCount || !b.DealCount) {
              return 0;
            }
            return b.DealCount - a.DealCount;
          case ChartType.CampaignsDealsAmount:
            if (!a.DealAmount || !b.DealAmount) {
              return 0;
            }
            return b.DealAmount - a.DealAmount;
          case ChartType.CampaignsImpressions:
            if (!a.ImpressionCount || !b.ImpressionCount) {
              return 0;
            }
            return b.ImpressionCount - a.ImpressionCount;
          case ChartType.CampaignsLeads:
            if (!a.LeadCount || !b.LeadCount) {
              return 0;
            }
            return b.LeadCount - a.LeadCount;
          case ChartType.CampaignsMeetings:
            if (!a.MeetingCount || !b.MeetingCount) {
              return 0;
            }
            return b.MeetingCount - a.MeetingCount;
          default:
            return 0;
        }
      });

      switch (chartType) {
        case ChartType.CampaignsBudget:
          this.stats.Budget = 0;
          break;
        case ChartType.CampaignsClicks:
          this.stats.ClickCount = 0;
          break;
        case ChartType.CampaignsDeals:
          this.stats.DealCount = 0;
          break;
        case ChartType.CampaignsDealsAmount:
          this.stats.DealAmount = 0;
          break;
        case ChartType.CampaignsImpressions:
          this.stats.ImpressionCount = 0;
          this.stats.Impressions1kPrice = 0;
          break;
        case ChartType.CampaignsLeads:
          this.stats.LeadCount = 0;
          break;
        case ChartType.CampaignsMeetings:
          this.stats.MeetingCount = 0;
          break;
      }
      
      if (chartType === ChartType.CampaignsBudget) {
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.Budget !== undefined && i.Cost) {
            this.stats.Budget += i.Cost;
          }
        });
      } else if (chartType === ChartType.CampaignsClicks) {
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.ClickCount !== undefined && i.ClickCount) {
            this.stats.ClickCount += i.ClickCount;
          }
        });
      } else if (chartType === ChartType.CampaignsDeals) {
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.DealCount !== undefined && i.DealCount) {
            this.stats.DealCount += i.DealCount;
          }
        });
      } else if (chartType === ChartType.CampaignsDealsAmount) {
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.DealAmount !== undefined && i.DealAmount) {
            this.stats.DealAmount += i.DealAmount;
          }
        });
      } else if (chartType === ChartType.CampaignsImpressions) {
        let impressions1kPriceCount = 0;
        let impressions1kPriceSum = 0;
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.ImpressionCount !== undefined && i.ImpressionCount) {
            this.stats.ImpressionCount += i.ImpressionCount;
          }
          if (i.Impressions1kPrice > 0) {
            impressions1kPriceCount++;
            impressions1kPriceSum += i.Impressions1kPrice;
          }
        });
        if (impressions1kPriceCount > 0)
        {
          this.stats.Impressions1kPrice = impressions1kPriceSum / impressions1kPriceCount;
        }
      } else if (chartType === ChartType.CampaignsLeads) {
        let avgPriceCount = 0;
        let avgPriceSum = 0;
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.LeadCount !== undefined && i.LeadCount) {
            this.stats.LeadCount += i.LeadCount;
          }
          if (i.CompanyLeadAveragePrice > 0) {
            avgPriceCount++;
            avgPriceSum += i.CompanyLeadAveragePrice;
          }
        });
        if(this.stats.Budget && this.stats.LeadCount) 
          this.stats.AverageLeadCost =  this.stats.Budget / this.stats.LeadCount;        
      } else if (chartType === ChartType.CampaignsMeetings) {
        newCampaignsWithStats.forEach((i: CampaignGridView) => {
          if (this.stats.MeetingCount !== undefined && i.MeetingCount) {
            this.stats.MeetingCount += i.MeetingCount;
          }
        });
      }
      
      let statCount = 0;
      switch (chartType) {
        case ChartType.CampaignsBudget:
          statCount = this.stats.Budget || 0;
          break;
        case ChartType.CampaignsClicks:
          statCount = this.stats.ClickCount || 0;
          break;
        case ChartType.CampaignsDeals:
          statCount = this.stats.DealCount || 0;
          break;
        case ChartType.CampaignsDealsAmount:
          statCount = this.stats.DealAmount || 0;
          break;
        case ChartType.CampaignsImpressions:
          statCount = this.stats.ImpressionCount || 0;
          break;
        case ChartType.CampaignsLeads:
          statCount = this.stats.LeadCount || 0;
          break;
        case ChartType.CampaignsMeetings:
          statCount = this.stats.MeetingCount || 0;
          break;
      }
      const otherMaxPercent = 5;  // all stats less than this in percent will be in "Other" category
      const otherMaxCount: number = statCount / 100 * otherMaxPercent;
      let otherCount: number = newCampaignsWithStats.filter((i: CampaignGridView) => {
        switch (chartType) {
          case ChartType.CampaignsBudget:
            return i.Cost && i.Cost < otherMaxCount;
          case ChartType.CampaignsClicks:
            return i.ClickCount && i.ClickCount < otherMaxCount;
          case ChartType.CampaignsDeals:
            return i.DealCount && i.DealCount < otherMaxCount;
          case ChartType.CampaignsDealsAmount:
            return i.DealAmount && i.DealAmount < otherMaxCount;
          case ChartType.CampaignsImpressions:
            return i.ImpressionCount && i.ImpressionCount < otherMaxCount;
          case ChartType.CampaignsLeads:
            return i.LeadCount && i.LeadCount < otherMaxCount;
          case ChartType.CampaignsMeetings:
            return i.MeetingCount && i.MeetingCount < otherMaxCount;
        }
      }).reduce((prevValue: number, campaign: CampaignGridView) => {
        switch (chartType) {
          case ChartType.CampaignsBudget:
            return campaign.Cost ? prevValue + campaign.Cost : 0;
          case ChartType.CampaignsClicks:
            return campaign.ClickCount ? prevValue + campaign.ClickCount : 0;
          case ChartType.CampaignsDeals:
            return campaign.DealCount ? prevValue + campaign.DealCount : 0;
          case ChartType.CampaignsDealsAmount:
            return campaign.DealAmount ? prevValue + campaign.DealAmount : 0;
          case ChartType.CampaignsImpressions:
            return campaign.ImpressionCount ? prevValue + campaign.ImpressionCount : 0;
          case ChartType.CampaignsLeads:
            return campaign.LeadCount ? prevValue + campaign.LeadCount : 0;
          case ChartType.CampaignsMeetings:
            return campaign.MeetingCount ? prevValue + campaign.MeetingCount : 0;
          default:
            return 0;
        }
      }, 0);
      newCampaignsWithStats = newCampaignsWithStats.filter((i: CampaignGridView) => {
        switch (chartType) {
          case ChartType.CampaignsBudget:
            return i.Cost && i.Cost >= otherMaxCount;
          case ChartType.CampaignsClicks:
            return i.ClickCount && i.ClickCount >= otherMaxCount;
          case ChartType.CampaignsDeals:
            return i.DealCount && i.DealCount >= otherMaxCount;
          case ChartType.CampaignsDealsAmount:
            return i.DealAmount && i.DealAmount >= otherMaxCount;
          case ChartType.CampaignsImpressions:
            return i.ImpressionCount && i.ImpressionCount >= otherMaxCount;
          case ChartType.CampaignsLeads:
            return i.LeadCount && i.LeadCount >= otherMaxCount;
          case ChartType.CampaignsMeetings:
            return i.MeetingCount && i.MeetingCount >= otherMaxCount;
        }
      });
      const otherTitle: string = i18n.t("Enums.ChannelMetadataType.Other").toString();
      if (otherCount > 0) {
        otherCount = parseFloat(otherCount.toFixed(2));
        const otherCampaigns: CampaignGridView = JSON.parse(JSON.stringify(campaignsWithStats[0]));
        otherCampaigns.ChannelTitle = otherTitle;
        otherCampaigns.Color = "#435c65";
        switch (chartType) {
          case ChartType.CampaignsBudget:
            otherCampaigns.Cost = otherCount;
            break;
          case ChartType.CampaignsClicks:
            otherCampaigns.ClickCount = otherCount;
            break;
          case ChartType.CampaignsDeals:
            otherCampaigns.DealCount = otherCount;
            break;
          case ChartType.CampaignsDealsAmount:
            otherCampaigns.DealAmount = otherCount;
            break;
          case ChartType.CampaignsImpressions:
            otherCampaigns.ImpressionCount = otherCount;
            break;
          case ChartType.CampaignsLeads:
            otherCampaigns.LeadCount = otherCount;
            break;
          case ChartType.CampaignsMeetings:
            otherCampaigns.MeetingCount = otherCount;
            break;
        }
        newCampaignsWithStats.push(otherCampaigns);
      }
      var predefinedColors = ["#0f69c9", "#ff9724", "#0093d0", "#269339", "#de473c", "#66bee3"];
      for (let i = 0; i < newCampaignsWithStats.length; i++) {
        if (!newCampaignsWithStats[i].Color) {
          newCampaignsWithStats[i].Color = predefinedColors[i % predefinedColors.length];
        }
      }
      // so color of first element will not be the same as last
      if (newCampaignsWithStats.length > predefinedColors.length && newCampaignsWithStats.length % predefinedColors.length === 1) {
        newCampaignsWithStats[newCampaignsWithStats.length - 1].Color = "#435c65";
      }
      colors = newCampaignsWithStats.map((i) => i.Color || '#000');
      data = newCampaignsWithStats.map((i) => {
        switch (chartType) {
          case ChartType.CampaignsBudget:
            return i.Cost ? parseFloat(i.Cost.toFixed(0)) : 0;
          case ChartType.CampaignsClicks:
            return i.ClickCount ? parseFloat(i.ClickCount.toFixed(0)) : 0;
          case ChartType.CampaignsDeals:
            return i.DealCount ? parseFloat(i.DealCount.toFixed(0)) : 0;
          case ChartType.CampaignsDealsAmount:
            return i.DealAmount ? parseFloat(i.DealAmount.toFixed(0)) : 0;
          case ChartType.CampaignsImpressions:
            return i.ImpressionCount ? parseFloat(i.ImpressionCount.toFixed(0)) : 0;
          case ChartType.CampaignsLeads:
            return i.LeadCount ? parseFloat(i.LeadCount.toFixed(0)) : 0;
          case ChartType.CampaignsMeetings:
            return i.MeetingCount ? parseFloat(i.MeetingCount.toFixed(0)) : 0;
          default:
            return 0;
        }
      });
      labels = newCampaignsWithStats.map((i) => {
        if (i.ChannelTitle !== otherTitle) {
          const channelTypeString: string = i18n.t(`Enums.ChannelMetadataType.${ChannelType[i.ChannelType]}`).toString();
          return `${i.CompanyTitle} ${channelTypeString}<br />${i.ChannelTitle}`;
        } else {
          return otherTitle;
        }
      });
    }
    return {
      datasets: [
        {
          backgroundColor: colors,
          data,
        },
      ],
      labels,
    };
  }

  getLineChartData(stats: CampaignsStatisticsByDate[] | null): LineChartData {
    const colors: string[] = [];
    const canvas = document.getElementById("line-chart") as HTMLCanvasElement;
    let gradient: CanvasGradient | undefined = undefined;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      gradient = ctx?.createLinearGradient(0, 0, 0, 200);
      gradient?.addColorStop(0, 'rgba(176, 217, 255, 1)');   
      gradient?.addColorStop(1, 'rgba(176, 217, 255, 0)');
    }
    const leadsDataset: ChartDataSets = {
      backgroundColor: gradient,
      borderColor: "#0093d0",
      borderWidth: 2,
      fill: true,
      label: i18n.t("Campaigns.Charts.Leads.Title").toString(),
    };
    const dealsDataset: ChartDataSets = {
      borderColor: "#269339",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Campaigns.Charts.Deals.Title").toString(),
    };
    const dealsAmountDataset: ChartDataSets = {
      borderColor: "#257942",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Campaigns.Charts.DealsAmount.Title").toString(),
    };
    const meatingsDataset: ChartDataSets = {
      borderColor: "#ff9724",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Campaigns.Charts.Meetings.Title").toString(),
    };
    const impressionsDataset: ChartDataSets = {
      borderColor: "#363636",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Campaigns.Charts.Impressions.Title").toString(),
    };
    const clicksDataset: ChartDataSets = {
      borderColor: "#b5b5b5",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Campaigns.Charts.Clicks.Title").toString(),
    };
    const budgetDataset: ChartDataSets = {
      borderColor: "#ff3860",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Campaigns.Charts.Budget.Title").toString(),
    };
    const labels: string[] = [];
    if (stats === null) {
      stats = [];
    }
    if (stats.length > 0) {
      const leadsData: ChartPoint[] = [];
      const dealsData: ChartPoint[] = [];
      const dealsAmountData: ChartPoint[] = [];
      const meetingsData: ChartPoint[] = [];
      const impressionsData: ChartPoint[] = [];
      const clicksData: ChartPoint[] = [];
      const budgetData: ChartPoint[] = [];
      for (let i = 0; i < stats.length; i++) {
        const stat = stats[i];
        const x: string = moment(stat.Date).format("YYYY-MM-DD");
        leadsData.push({
          x,
          y: stat.LeadCount,
        });
        dealsData.push({
          x,
          y: stat.DealCount,
        });
        dealsAmountData.push({
          x,
          y: stat.DealsAmount,
        });
        meetingsData.push({
          x,
          y: stat.MeetingCount,
        });
        impressionsData.push({
          x,
          y: stat.ImpressionCount,
        });
        clicksData.push({
          x,
          y: stat.ClickCount,
        });
        budgetData.push({
          x,
          y: stat.Cost,
        });
      }
      leadsDataset.data = leadsData;
      dealsDataset.data = dealsData;
      dealsAmountDataset.data = dealsAmountData;
      meatingsDataset.data = meetingsData;
      impressionsDataset.data = impressionsData;
      clicksDataset.data = clicksData;
      budgetDataset.data = budgetData;
      if (this.lineChartOptions.scales && this.lineChartOptions.scales.yAxes && this.lineChartOptions.scales.yAxes[0].ticks) {
        const numbers: number[] = [];
        if (this.showInByDateChart.includes(ChartType.CampaignsClicks)) {
          numbers.push(...stats.map((i) => i.ClickCount));
        }
        if (this.showInByDateChart.includes(ChartType.CampaignsDeals)) {
          numbers.push(...stats.map((i) => i.DealCount));
        }
        if (this.showInByDateChart.includes(ChartType.CampaignsDealsAmount)) {
          numbers.push(...stats.map((i) => i.DealsAmount));
        }
        if (this.showInByDateChart.includes(ChartType.CampaignsBudget)) {
          numbers.push(...stats.map((i) => i.Cost));
        }
        if (this.showInByDateChart.includes(ChartType.CampaignsImpressions)) {
          numbers.push(...stats.map((i) => i.ImpressionCount));
        }
        if (this.showInByDateChart.includes(ChartType.CampaignsLeads)) {
          numbers.push(...stats.map((i) => i.LeadCount));
        }
        if (this.showInByDateChart.includes(ChartType.CampaignsMeetings)) {
          numbers.push(...stats.map((i) => i.MeetingCount));
        }
        this.lineChartOptions.scales.yAxes[0].ticks.suggestedMax = Math.max(...numbers);
      }
    }
    const datasets: ChartDataSets[] = [];
    if (this.showInByDateChart.includes(ChartType.CampaignsClicks)) {
      datasets.push(clicksDataset);
    }
    if (this.showInByDateChart.includes(ChartType.CampaignsDeals)) {
      datasets.push(dealsDataset);
    }
    if (this.showInByDateChart.includes(ChartType.CampaignsDealsAmount)) {
      datasets.push(dealsAmountDataset);
    }
    if (this.showInByDateChart.includes(ChartType.CampaignsBudget)) {
      datasets.push(budgetDataset);
    }
    if (this.showInByDateChart.includes(ChartType.CampaignsImpressions)) {
      datasets.push(impressionsDataset);
    }
    if (this.showInByDateChart.includes(ChartType.CampaignsLeads)) {
      datasets.push(leadsDataset);
    }
    if (this.showInByDateChart.includes(ChartType.CampaignsMeetings)) {
      datasets.push(meatingsDataset);
    }
    return {
      chartData: {
        datasets,
        labels,
      },
      totalBudget: stats.map((i) => i.Cost).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalClicks: stats.map((i) => i.ClickCount).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalDeals: stats.map((i) => i.DealCount).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalDealsAmount: stats.map((i) => i.DealsAmount).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalImpressions: stats.map((i) => i.ImpressionCount).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalLeads: stats.map((i) => i.LeadCount).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalMeetings: stats.map((i) => i.MeetingCount).reduce((partialSum: number, a: number) => partialSum + a, 0),
    };
  }

  handleRoiTooltipPosition() {
    const el: Vue = this.$refs.roiTooltip as Vue;
    if (!el) {
      return;
    }
    const tooltipTriggers: HTMLCollectionOf<Element> = el.$el.getElementsByClassName("tooltip-trigger");
    if (tooltipTriggers.length === 0) {
      return;
    }
    const tooltipTrigger = tooltipTriggers[0];
    const tooltipContents: HTMLCollectionOf<Element> = el.$el.getElementsByClassName("tooltip-content");
    if (tooltipContents.length === 0) {
      return;
    }
    const tooltipContent: HTMLDivElement = tooltipContents[0] as HTMLDivElement;

    const screenPadding = 56;
    const triggerRect = tooltipTrigger.getBoundingClientRect();
    const tooltipRect = tooltipContent.getBoundingClientRect();
    if (tooltipRect.width === 0) {
      setTimeout(() => {
        this.handleRoiTooltipPosition();
      }, 100);
      return;
    }
    if (tooltipRect.width > window.innerWidth) {
      tooltipContent.style.left = `${screenPadding}px`;
      tooltipContent.style.right = "auto";
      tooltipContent.style.transform = `translateX(${-triggerRect.x}px)`;
      tooltipContent.style.whiteSpace = "normal";
      tooltipContent.style.width = `${window.innerWidth - 2 * screenPadding}px`;
    } else {
      if (tooltipRect.x < 0) {
        tooltipContent.style.left = "0";
        tooltipContent.style.right = "auto";
        tooltipContent.style.transform = `translateX(${-triggerRect.x + screenPadding}px)`;
      } else if (tooltipRect.right > window.innerWidth) {
        tooltipContent.style.left = "auto";
        tooltipContent.style.right = "0";
        tooltipContent.style.transform = `translateX(${(window.innerWidth - triggerRect.right) - screenPadding}px)`;
      }
    }
    const rtlArrowMargin = 3;
    const arrowPos: string = HelperService.isRtl()
      ? `${window.innerWidth - triggerRect.right - triggerRect.width / 2 + rtlArrowMargin - screenPadding}px`
      : `${triggerRect.left + triggerRect.width / 2 - screenPadding}px`;
    document.documentElement.style.setProperty("--tooltip-arrow-pos", arrowPos);
    tooltipContent.style.opacity = "1";
  }

  setGraphActive(value: number, chartType: ChartType) {
    this.campaignsGraphActive = value;
    this.$nextTick(() => {
      switch (chartType) {
        case ChartType.CampaignsByDate:
          (this.$refs.byDateChart as any).refreshChart();
          break;
        default:
          (this.$refs.impressionsChart as any).refreshChart();
          (this.$refs.clicksChart as any).refreshChart();
          (this.$refs.budgetChart as any).refreshChart();
          (this.$refs.leadsChart as any).refreshChart();
          (this.$refs.meetingsChart as any).refreshChart();
          (this.$refs.dealsChart as any).refreshChart();
          break;
      }
    });
  }

  toggleGraphLoader(show: boolean, loaderComponent: LoaderComponent | undefined, container: Element) {
    if (!container) {
      return;
    }
    if (show) {
      loaderComponent = this.$loading.show({
        container
      });
    } else if (loaderComponent) {
      loaderComponent.hide();
    }
    return loaderComponent;
  }

  //#endregion Private methods
}

interface LineChartData {
  totalBudget?: number;
  totalClicks?: number;
  totalDeals?: number;
  totalDealsAmount?: number;
  totalImpressions?: number;
  totalLeads?: number;
  totalMeetings?: number;
  chartData?: ChartData;
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.section-graphs {
  background: #fff;
  border: 1px solid #d3d6e2;
  border-radius: 4px;
  margin-bottom: 30px;
  .graph {
    &.graph-pie {
      display: flex;
      align-items: stretch;
      @media (max-width: 991px) {
        width: 100%;
      }
      .wblock {
        width: 100%;
        padding: 20px;
      }
    }
  }

  .chart-list {
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    margin: 0 -1px -1px 0;
    @media (max-width: 575px) {
      display: block;
    }
    .chart-item {
      padding: 10px 24px;
      width: 16.6667%;
      flex: 0 0 16.6667%;
      border-bottom: 1px solid #d3d6e2;
      border-right: 1px solid #d3d6e2;
      position: relative;
      @media (max-width: 1599px) {
        padding: 10px 16px;
      }
      @media (max-width: 1399px) {
        width: 33.3333%;
        flex: 0 0 33.3333%;
        @media (resolution: 120dpi) {
          width: 16.6667%;
          flex: 0 0 16.6667%;
        }
      }
      @media (max-width: 1199px) and (resolution: 120dpi) {
        width: 33.3333%;
        flex: 0 0 33.3333%;
      }
      @media (max-width: 991px) {
        width: 50%;
        flex: 0 0 50%;
        padding: 10px 16px 20px;
      }
      @media (max-width: 575px) {
        width: 100%;
      }
      .chart-title {
        font-size: 17px;
        font-weight: 600;
        min-height: 60px;

        .b-tooltip {
          margin: 0 .2rem;
        }

        .chart-title-t {
          display: block;
        }
        .chart-title-b {
          display: block;
          @media (max-width: 991px) {
            display: none;
          }
          &.text-blue {
            color: $primary;
          }
          &.text-yellow {
            color: $warning;
          }
          &.text-green {
            color: $success;
          }
          &.text-grey {
            color: #aaa;
          }
        }
        .chart-title-b-m {
          color: #aaa;
          font-size: 16px;
          display: block;
          line-height: 1.2;
          @media (min-width: 991px) {
            display: none;
          }
        }
      }
      .chart-titles {
        display: flex;
        .chart-title {
          padding: 0 0 5px 5px;
          &.chart-title-second {
            margin-right: auto;
            text-align: left;
            padding: 0 5px 5px 0;
            @media (max-width: 991px) {
              display: none;
            }
          }
        }
      }
    }
    .chart-container {
      position: relative;
      justify-content: center;
      margin: 0 auto 20px;
    }

    .chart-labels {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      
      .chart-label {
        display: flex;
        align-items: center;
        margin: 0 7px 5px;
        .color {
          width: 6px;
          height: 6px;
          flex: 0 0 6px;
          margin: 2px 0 0 5px;
        }
        .txt {
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          flex: 1;
        }
      }
    }
  }

  .graph {
    &.graph-line {
      .chart-item {
        padding: 40px 20px 20px;
        display: flex;
        position: relative;
      }
      .chart-labels {
        flex: 0 0 220px;
        padding: 0 10px 0 45px;
        position: relative;
        width: 220px;

        .chart-label {
          display: flex;
          align-items: center;
          margin: 0 0 5px;

          .color {
            width: 6px;
            height: 6px;
            flex: 0 0 6px;
            margin: 2px 0 0 9px;
          }

          .field {
            line-height: .5;
            margin-bottom: 0;
            visibility: hidden;
            width: 0;
          }

          .txt {
            cursor: pointer;
            flex: 1;
            font-size: 14px;
            font-weight: 600;

            &.disabled {
              color: $disabled;
            }
          }
        }
        hr {
          margin: 20px 0 18px;
          background: #d3d6e2;
          height: 1px;
        }
      }
      .chart-container {
        flex: 1;
        width: 100%;
        height: 250px;
      }
    }
  }

  .graphs-bottom-panel {
    display: flex;
    align-items: center;
    padding: 18px 21px;
    border-top: 1px solid $lightd;
    @media (max-width: 991px) {
      display: block;
      padding: 0;
    }
    .graphs-roi {
      display: flex;
      font-size: 18px;
      align-items: center;
      margin: 0 3px 0 auto;
      min-width: 300px;
      @media (max-width: 991px) {
        padding: 15px 25px;
        border-bottom: 1px solid $lightd;
        margin: 0;
        min-width: 200px;
      }

      .roi-label {
        margin: 0 0 0 7px;
        font-weight: 600;
      }
      .roi-val {
        margin-left: 10px;
      }
      .roi-help {
        line-height: 0;
        color: $dark4;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
          // color: $primary;
        }
      }
    }
    .graphs-view-tabs {
      display: flex;
      align-items: center;
      .tab {
        margin: 0 15px;
        display: flex;
        align-items: center;
        font-size: 18px;
        cursor: pointer;
        font-weight: 600;
        transition: all 0.2s;
        &:hover {
          color: #666;
        }
        .icon-w {
          margin-left: 9px;
        }
        &.is-active {
          color: $primary;
        }
      }
    }
    .graphs-date-comparison {
      display: none;
      margin-right: auto;
      min-width: 300px;
      text-align: left;
      @media (max-width: 991px) {
        margin: 0;
        padding: 30px 25px;
        min-width: 200px;
      }
      @media (max-width: 359px) {
        padding: 20px 15px;
      }
      .button {
        @media (max-width: 991px) {
          width: 100%;
          font-size: 17px;
          height: 35px;
        }
      }
    }
  }
}

html[dir="ltr"] {
  .section-graphs {
    .chart-list {
      margin: 0 0 -1px -1px;
      .chart-item {
        border-right: none;
        border-left: 1px solid #d3d6e2;
        .chart-titles {
          .chart-title {
            padding: 0 5px 5px 0;
            &.chart-title-second {
              text-align: right;
              margin: 0 0 0 auto;
              padding: 0 0 5px 5px;
            }
          }
        }
      }
      .chart-labels {
        .chart-label {
          .color {
            margin: 2px 5px 0 0;
          }
        }
      }
    }
    .graph.graph-line {
      .chart-labels {
        padding: 0 45px 0 10px;
        .chart-label {
          .color {
            margin: 2px 9px 0 0;
          }
        }
      }
    }

    .graphs-bottom-panel {
      .graphs-roi {
        margin: 0 auto 0 3px;
        .roi-label {
          margin: 0 7px 0 0;
        }
        .roi-val {
          margin: 0 10px 0 0;
        }
      }
      .graphs-view-tabs {
        .tab {
          .icon-w {
            margin: 0 9px 0 0;
          }
        }
      }
      .graphs-date-comparison {
        margin: 0 0 0 auto;
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss">
:root {
  --tooltip-arrow-pos: 50%;
}

.graphs-roi .b-tooltip.is-dark.is-multiline.is-medium .tooltip-content {
  background: #303b41;
  font-size: 16px;
  font-weight: normal;
  opacity: 0;
  padding: 15px 18px 18px;
  text-align: start;
  white-space: nowrap;
  width: auto;

  @media (max-width: 1199px) {
    min-width: 280px;
    width: auto;
  }

  @media (max-width: 479px) {
    left: -40px;
    transform: none;
  }

  &:before {
    border-width: 7px;
    left: auto;
    right: var(--tooltip-arrow-pos);
  }
}

html[dir="ltr"] {
  .graphs-roi .b-tooltip.is-dark.is-multiline.is-medium .tooltip-content {
    @media (max-width: 479px) {
      left: auto;
      right: -40px;
    }

    &:before {
      left: var(--tooltip-arrow-pos);
      right: auto;
    }
  }
}
</style>
